import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class DynFormDbTableDefinition extends DbTableDefinition {
  tableName = 'dynForms';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
       label TEXT NOT NULL,
       databag LONGTEXT,
       name VARCHAR(45),
       showatfinishdialog BOOLEAN,
       expiration VARCHAR(10),
       extid VARCHAR(45),
       formdata TEXT);`;

  constructor() {
    super();
    // Add UpdateStatements to Map
    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({
        table: this.tableName,
        col: 'formtranslations',
        type: 'TEXT',
      });
      this.alterStatements.push({
        table: this.tableName,
        col: 'finalizeday',
        type: 'BOOLEAN',
      });
    } else {
      this.updateStatements.set(21, [
        `ALTER TABLE ${this.tableName} ADD COLUMN formtranslations TEXT;`,
      ]);
      this.updateStatements.set(28, [
        `ALTER TABLE ${this.tableName} ADD COLUMN finalizeday BOOLEAN;`,
      ]);
    }
  }
}
